import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/store/user'
import LoginView from '../views/LoginView.vue'
import AdminView from '../views/AdminView.vue'
import ControlTowerView from '../views/ControlTowerView.vue'
import ControlViewTwo from '../views/ControlViewTwo.vue'
import WecomLoginSuccess from '../views/WecomLoginSuccess.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { guest: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminView,
    meta: { roles: ['ADMIN'] }
  },
  {
    path: '/',
    name: 'ControlTower',
    component: ControlTowerView,
    meta: { roles: ['CENTER_LEAD', 'DEPT_LEAD'] }
  },
  {
    path: '/control-tower-two',
    name: 'ControlTowerTwo',
    component: ControlViewTwo,
    meta: { roles: ['MANAGER'] }
  },
  {
    path: '/wecom-login-success',
    name: 'WecomLoginSuccess',
    component: WecomLoginSuccess,
    meta: { guest: true }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const roleHomeMap = {
  ADMIN: '/admin',
  CENTER_LEAD: '/',
  DEPT_LEAD: '/',
  MANAGER: '/control-tower-two'
}

router.beforeEach((to, from, next) => {
  const userStore = useUserStore()

  if (to.meta.guest) {
    if (userStore.isLoggedIn) {
      return next(roleHomeMap[userStore.highestRole] || '/')
    }
    return next()
  }

  if (!userStore.isLoggedIn) {
    return next('/login')
  }

  const requiredRoles = to.meta.roles
  if (requiredRoles && !requiredRoles.includes(userStore.highestRole)) {
    return next(roleHomeMap[userStore.highestRole] || '/')
  }

  next()
})

export default router
